module.exports = __webpack_public_path__ + "static/media/choose_us_3.3afd12ce.png";